import { Button } from '@/components/atoms'
import { SaveReportContent } from '@/components/molecules/SaveReportContent/SaveReportContent'
import { GetActiveManagementRequestParams } from '@/hooks'
import { IntervalReportSettings } from '@/hooks/useApi/useActiveManagementApi/types'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'
import { useTranslation } from 'react-i18next'
import { IntervalDataExportDropdown } from '../../IntervalDataExportDropdown/IntervalDataExportDropdown'

export type IntervalActionsProps = {
    filters: Partial<GetActiveManagementRequestParams>
    reportSettings: IntervalReportSettings
}

export const IntervalActions: React.FC<IntervalActionsProps> = ({
    filters,
    reportSettings,
}) => {
    const { t } = useTranslation('translations')

    const setModalState = useGlobalModalStore((state) => state.setModalState)
    const closeModal = () => {
        setModalState({ isOpen: false })
    }

    const labels = {
        saveButton: t('reporting.save_report.save_report_modal.save_button'),
        loadingSaveButton: t(
            'reporting.save_report.save_report_modal.loading_save_button'
        ),
    }

    const handleClickSaveReport = () => {
        setModalState({
            isOpen: true,
            title: t('reporting.save_report.save_report_modal.title'),
            description: t(
                'reporting.save_report.save_report_modal.description'
            ),
            content: () => (
                <SaveReportContent reportType="interval-data" labels={labels} />
            ),
            onClose: closeModal,
        })
    }

    return (
        <div className="flex gap-4">
            <Button
                name="saveReport"
                size="large"
                variant="outlinePrimary"
                onClick={handleClickSaveReport}
                className="font-medium"
            >
                {t('common.save_report')}
            </Button>
            <IntervalDataExportDropdown
                filters={filters}
                reportSettings={reportSettings}
            />
        </div>
    )
}
